import { useQuery } from '@tanstack/react-query';

import { setDefaultApiHeader } from 'shared/api/lib';
import { queryKeys, useApi } from 'shared/api/model';

export const useGetAuthCSRF = () => {
  const api = useApi('AuthApi');
  const { queryKey } = queryKeys.auth.csrf;

  return useQuery({
    queryKey,
    queryFn: () => api.getCsrfToken(),
    select: (data) => {
      setDefaultApiHeader('X-XSRF-TOKEN', data.token);
      return data.token;
    },
  });
};
